import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=40572881&scoped=true"
import script from "./Pager.vue?vue&type=script&lang=ts"
export * from "./Pager.vue?vue&type=script&lang=ts"
import style0 from "./Pager.vue?vue&type=style&index=0&id=40572881&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40572881",
  null
  
)

export default component.exports